export default {
  computed : {
    invoiceSubjects() {
      return [
        {
          text: "ارسال نشده",
          value: "0",
        },
        {
          text: "اصلی",
          value: "1",
        },
        {
          text: "اصلاحی",
          value: "2",
        },
        {
          text: "ابطالی",
          value: "3",
        },
        {
          text: "برگشت از فروش",
          value: "4",
        }
      ]
    }
  }
}